import script from "./OrderReplacements.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderReplacements.vue?vue&type=script&setup=true&lang=ts"

import "./OrderReplacements.vue?vue&type=style&index=0&id=785f91cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-785f91cc"]])

export default __exports__